// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img2/login_modal_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EU5OnG9Y {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  z-index: 2000;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  padding: 2rem 1rem;
}
@media (max-width: 767px) {
  .EU5OnG9Y {
    padding: 0.5rem;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
  }
}
.op9GWVqJ {
  position: relative;
  width: 100%;
  max-width: 29.25rem;
  box-sizing: border-box;
  height: auto;
  border-style: solid;
  border-width: 196.23157895px 39.41052632px 55.83157895px 39.41052632px;
  border-color: transparent;
  border-image-source: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border-image-slice: 239.4 48 68.4 48 fill;
  border-image-repeat: stretch;
  border-image-width: 196.23157895px 39.41052632px 55.83157895px 39.41052632px;
  -webkit-animation: Ahg0kVSH 0.3s ease;
          animation: Ahg0kVSH 0.3s ease;
  overflow: visible;
}
@media (max-width: 767px) {
  .op9GWVqJ {
    max-width: min(22rem, 92vw);
    border-width: 147.84px 29.64210526px 42.24px 29.64210526px;
    border-image-width: 147.84px 29.64210526px 42.24px 29.64210526px;
    max-height: calc(100dvh - 1.5rem);
  }
}
@-webkit-keyframes Ahg0kVSH {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
@keyframes Ahg0kVSH {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
.AHoSyi2Q {
  background: none;
  margin: 0;
  outline: none;
  font-family: inherit;
  position: absolute;
  top: -0.75rem;
  right: -2rem;
  width: 4rem;
  height: 4rem;
  padding: 0;
  border: none;
  background: transparent;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  cursor: pointer;
  z-index: 3;
  -webkit-transition: -webkit-transform 0.2s ease;
  transition: -webkit-transform 0.2s ease;
  transition: transform 0.2s ease;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}
.AHoSyi2Q:hover {
  -webkit-transform: scale(1.05);
          transform: scale(1.05);
}
.AHoSyi2Q:active {
  -webkit-transform: scale(0.95);
          transform: scale(0.95);
}
@media (max-width: 767px) {
  .AHoSyi2Q {
    top: -0.5rem;
    right: -1.25rem;
    width: 3.25rem;
    height: 3.25rem;
  }
}
.VcpyTpr2 {
  width: 100%;
  height: 100%;
  position: absolute;
  top: -4rem;
  display: block;
  -o-object-fit: contain;
     object-fit: contain;
}
@media (max-width: 767px) {
  .VcpyTpr2 {
    top: -2.75rem;
  }
}
.r2Ii3AwV {
  position: absolute;
  top: -6.2rem;
  left: 50%;
  -webkit-transform: translate(-50%, -42%);
          transform: translate(-50%, -42%);
  z-index: 2;
  pointer-events: none;
}
@media (max-width: 767px) {
  .r2Ii3AwV {
    top: -5.25rem;
    -webkit-transform: translate(-50%, -36%);
            transform: translate(-50%, -36%);
  }
}
.a_OTZcS9 {
  width: 8rem;
  height: auto;
  display: block;
}
@media (max-width: 767px) {
  .a_OTZcS9 {
    width: 6rem;
  }
}
.RZEapaIE {
  padding: 0.5rem 1.25rem 0.25rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
}
@media (max-width: 767px) {
  .RZEapaIE {
    padding: 0.125rem 1rem 0.125rem;
  }
}
.QnNUFumx {
  width: 9rem;
  height: auto;
  display: block;
  margin-bottom: 0.25rem;
}
@media (max-width: 767px) {
  .QnNUFumx {
    width: 6.5rem;
    margin-bottom: 0.125rem;
  }
}
.V11N6Xmb {
  margin: 0 0 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: #585858;
  text-align: center;
}
@media (max-width: 767px) {
  .V11N6Xmb {
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    line-height: 1.35;
  }
}
.LQ4GV5UQ {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  gap: 1rem;
}
@media (max-width: 767px) {
  .LQ4GV5UQ {
    gap: 0.5rem;
  }
}
.uKixh81J {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  gap: 0.25rem;
  width: 100%;
}
.TpCqxV6V {
  font-size: 0.75rem;
  color: #f5222d;
  line-height: 1.4;
}
.yWQ_F6Pc,
.Ktj2rkjK {
  width: 100%;
  height: 3rem;
  padding: 0 1rem;
  border: none;
  border-radius: 0.625rem;
  font-size: 1rem;
  color: #585858;
  outline: none;
  background: #FFF1DA;
  -webkit-transition: box-shadow 0.2s ease;
  transition: box-shadow 0.2s ease;
}
.yWQ_F6Pc:focus,
.Ktj2rkjK:focus {
  box-shadow: 0 0 0 2px rgba(251, 121, 1, 0.35);
}
.yWQ_F6Pc::-webkit-input-placeholder, .Ktj2rkjK::-webkit-input-placeholder {
  color: #c8b08a;
}
.yWQ_F6Pc::-moz-placeholder, .Ktj2rkjK::-moz-placeholder {
  color: #c8b08a;
}
.yWQ_F6Pc::placeholder,
.Ktj2rkjK::placeholder {
  color: #c8b08a;
}
@media (max-width: 767px) {
  .yWQ_F6Pc,
  .Ktj2rkjK {
    height: 2.625rem;
    font-size: 0.875rem;
    padding: 0 0.75rem;
  }
}
.lA8J5cGz {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  gap: 0.5rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  width: 100%;
  min-width: 0;
}
.Ktj2rkjK {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  min-width: 0;
}
.vEWt5a1l {
  width: 8.5rem;
  height: 3rem;
  border-radius: 0.625rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  background: #FFF1DA;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  cursor: pointer;
  overflow: hidden;
}
.vEWt5a1l img {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
  display: block;
}
@media (max-width: 767px) {
  .vEWt5a1l {
    width: 6.25rem;
    height: 2.625rem;
    max-width: 40%;
  }
}
.JHCNrsBG {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
}
.JHCNrsBG::after {
  content: '';
  width: 1.4rem;
  height: 1.4rem;
  border: 2px solid #d0d0d0;
  border-top-color: #fb7901;
  border-radius: 50%;
  -webkit-animation: Z4nBBmnM 0.8s linear infinite;
          animation: Z4nBBmnM 0.8s linear infinite;
}
@-webkit-keyframes Z4nBBmnM {
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes Z4nBBmnM {
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.IM4vIx9F {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}
@media (max-width: 767px) {
  .IM4vIx9F {
    gap: 0.375rem;
  }
}
.s8GPRhmT {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.25rem;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.wQN8nXim {
  width: 1.125rem;
  height: 1.125rem;
  margin-top: 0.125rem;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 1px solid #d8c4a0;
  border-radius: 0.25rem;
  background: #ffffff;
  position: relative;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.wQN8nXim:checked {
  border-color: #fb7901;
  background: #fb7901;
}
.wQN8nXim:checked::after {
  content: '';
  position: absolute;
  top: 0.125rem;
  left: 0.3125rem;
  width: 0.25rem;
  height: 0.5rem;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
          transform: rotate(45deg);
}
.akpTNald {
  font-size: 0.875rem;
  color: #c9a574;
  line-height: 1.5;
  font-weight: 600;
}
@media (max-width: 767px) {
  .akpTNald {
    font-size: 0.625rem;
    line-height: 1.4;
  }
}
.TspOke8b {
  color: #626cda;
  text-decoration: none;
}
.TspOke8b:hover {
  text-decoration: underline;
}
.ebRjCfxY {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  gap: 0.25rem;
  width: 100%;
  text-align: center;
}
.oARyIHjo {
  color: #f5222d;
  font-size: 1rem;
}
.rcBvPlaR {
  font-size: 0.875rem;
  color: #f5222d;
  line-height: 1.5;
  font-weight: 600;
}
.uUYqLxgA {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  gap: 0.375rem;
  width: 100%;
  text-align: center;
  margin: 2rem 0;
}
.YGS_s4J6 {
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  text-align: left;
}
._5Cus_dE {
  margin-top: 0.125rem;
  width: 1.25rem;
  height: 1.25rem;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  -o-object-fit: contain;
     object-fit: contain;
}
.VHjDJIIb {
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  color: #fc6c6c;
  line-height: 1.5;
}
.TDeoAMfO {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  gap: 1rem;
  width: 100%;
  margin-top: 0.5rem;
}
@media (max-width: 767px) {
  .TDeoAMfO {
    gap: 0.5rem;
    margin-top: 0.125rem;
  }
}
.iNq11l8G,
.hErnFAS6 {
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  outline: none;
  font-family: inherit;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  width: 100%;
  height: 3.125rem;
  border: none;
  border-radius: 999px;
  color: #ffffff;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  box-sizing: border-box;
  cursor: not-allowed;
  background: #d3d3d3;
  -webkit-transition: background 0.2s ease, -webkit-transform 0.2s ease;
  transition: background 0.2s ease, -webkit-transform 0.2s ease;
  transition: background 0.2s ease, transform 0.2s ease;
  transition: background 0.2s ease, transform 0.2s ease, -webkit-transform 0.2s ease;
}
.iNq11l8G.KwGtNPpT,
.hErnFAS6.KwGtNPpT,
.iNq11l8G.fOX7H6je,
.hErnFAS6.fOX7H6je {
  background: #ffc692;
  cursor: not-allowed;
}
.iNq11l8G.n4XCYo7M,
.hErnFAS6.n4XCYo7M,
.iNq11l8G.oBXMq5iF,
.hErnFAS6.oBXMq5iF {
  background: #fb7901;
  cursor: pointer;
}
.iNq11l8G.n4XCYo7M:hover,
.hErnFAS6.n4XCYo7M:hover,
.iNq11l8G.oBXMq5iF:hover,
.hErnFAS6.oBXMq5iF:hover {
  background: #e66f00;
}
.iNq11l8G.n4XCYo7M:active,
.hErnFAS6.n4XCYo7M:active,
.iNq11l8G.oBXMq5iF:active,
.hErnFAS6.oBXMq5iF:active {
  -webkit-transform: scale(0.98);
          transform: scale(0.98);
}
@media (max-width: 767px) {
  .iNq11l8G,
  .hErnFAS6 {
    height: 2.75rem;
    font-size: 1.125rem;
  }
}
.tk7AGilR {
  display: block;
  line-height: 1;
}
.nLla_5zF {
  width: 100%;
  text-align: center;
  margin-top: 0.5rem;
}
@media (max-width: 767px) {
  .nLla_5zF {
    margin-top: 0.25rem;
  }
}
.w40HhhDh {
  background: none;
  margin: 0;
  outline: none;
  font-family: inherit;
  color: #626cda;
  font-size: 0.875rem;
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 0;
  text-decoration: underline;
}
.w40HhhDh:hover {
  opacity: 0.85;
}
.jcxd1X4S {
  -webkit-align-self: center;
          align-self: center;
}
.YdWVriKx {
  width: 100%;
  padding-top: 0.5rem;
}
@media (max-width: 767px) {
  .YdWVriKx {
    padding-top: 0;
  }
}
.XvE1v2Gj {
  text-align: center;
  margin-bottom: 1.5rem;
}
@media (max-width: 767px) {
  .XvE1v2Gj {
    margin-bottom: 0.5rem;
  }
}
.OeJHFi4I {
  font-size: 1rem;
  color: #585858;
  line-height: 1.6;
  margin: 0 0 0.25rem;
}
@media (max-width: 767px) {
  .OeJHFi4I {
    font-size: 0.875rem;
  }
}
.Q7xmq0i0 {
  color: #626cda;
}
.udIRIWCo {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  margin-bottom: 2rem;
}
@media (max-width: 767px) {
  .udIRIWCo {
    gap: 0.375rem;
    margin-bottom: 0.5rem;
    margin: 1rem 0 2rem 0;
  }
}
.L_6sNlDz {
  width: 3.3rem;
  height: 3.7rem;
  border: 2px solid #FFD9B6;
  border-radius: 0.625rem;
  text-align: center;
  font-size: 1.25rem;
  font-weight: 700;
  color: #585858;
  outline: none;
  background: #FFF1DA;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.L_6sNlDz:focus,
.L_6sNlDz.aD1jR3B1 {
  border-color: #fb7901;
}
.L_6sNlDz.hcJWp3gO {
  border-color: #f5222d;
}
@media (max-width: 767px) {
  .L_6sNlDz {
    width: 2.375rem;
    height: 2.75rem;
    font-size: 1.125rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LoginModal/LoginModal.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AA6BA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;EC2BA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;ED3BA,kBAAA;AA1BF;ACNE;EAAA;IDmCE,eAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;EAzBF;AACF;AA4BA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,sEAAA;EACA,yBAAA;EACA,4DAAA;EACA,yCAAA;EACA,4BAAA;EACA,4EAAA;EACA,qCAAA;UAAA,6BAAA;EACA,iBAAA;AA1BF;AC5BE;EAAA;IDwDE,2BAAA;IAYA,0DAAA;IAEA,gEAAA;IAEA,iCAAA;EArCF;AACF;AAwCA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAtCF;EAwCA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAtCF;AACF;AA8BA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAtCF;EAwCA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAtCF;AACF;AAyCA;ECcE,gBAAA;EAEA,SAAA;EAEA,aAAA;EACA,oBAAA;EDjBA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,+CAAA;EAAA,uCAAA;EAAA,+BAAA;EAAA,4DAAA;AApCF;AAsCE;EACE,8BAAA;UAAA,sBAAA;AApCJ;AAuCE;EACE,8BAAA;UAAA,sBAAA;AArCJ;ACxEE;EAAA;IDiHE,YAAA;IACA,eAAA;IACA,cAAA;IACA,eAAA;EArCF;AACF;AAwCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,sBAAA;KAAA,mBAAA;AAtCF;ACxFE;EAAA;IDiIE,aAAA;EArCF;AACF;AAwCA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,wCAAA;UAAA,gCAAA;EACA,UAAA;EACA,oBAAA;AAtCF;ACrGE;EAAA;ID8IE,aAAA;IACA,wCAAA;YAAA,gCAAA;EArCF;AACF;AAwCA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAtCF;AChHE;EAAA;IDyJE,WAAA;EArCF;AACF;AAwCA;EACE,+BAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;AAtCF;AC3HE;EAAA;IDoKE,+BAAA;EArCF;AACF;AAwCA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AAtCF;ACtIE;EAAA;ID+KE,aAAA;IACA,uBAAA;EArCF;AACF;AAwCA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAtCF;ACnJE;EAAA;ID4LE,qBAAA;IACA,mBAAA;IACA,iBAAA;EArCF;AACF;AAwCA;EACE,WAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,SAAA;AAtCF;AChKE;EAAA;IDyME,WAAA;EArCF;AACF;AAwCA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,YAAA;EACA,WAAA;AAtCF;AAyCA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AAvCF;AA0CA;;EAEE,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EAAA,gCAAA;AAxCF;AA0CE;;EACE,6CAAA;AAvCJ;AA0CE;EACE,cAAA;AAvCJ;AAsCE;EACE,cAAA;AAvCJ;AAsCE;;EACE,cAAA;AAvCJ;ACrME;EAAA;;IDgPE,gBAAA;IACA,mBAAA;IACA,kBAAA;EAtCF;AACF;AAyCA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,WAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,WAAA;EACA,YAAA;AAvCF;AA0CA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,YAAA;AAxCF;AA2CA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,mBAAA;EACA,sBAAA;UAAA,cAAA;EACA,eAAA;EACA,gBAAA;AAzCF;AA+BA;EAaI,WAAA;EACA,YAAA;EACA,sBAAA;KAAA,mBAAA;EACA,cAAA;AAzCJ;AC1OE;EAAA;IDuRE,cAAA;IACA,gBAAA;IACA,cAAA;EAzCF;AACF;AA4CA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;AA1CF;AA4CE;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gDAAA;UAAA,wCAAA;AA1CJ;AA8CA;EACE;IACE,iCAAA;YAAA,yBAAA;EA5CF;AACF;AAyCA;EACE;IACE,iCAAA;YAAA,yBAAA;EA5CF;AACF;AA+CA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,WAAA;EACA,WAAA;AA7CF;AC5QE;EAAA;ID4TE,aAAA;EA5CF;AACF;AA+CA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AA7CF;AAgDA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;UAAA,cAAA;EACA,qBAAA;OAAA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EAAA,yBAAA;AA9CF;AAgDE;EACE,qBAAA;EACA,mBAAA;AA9CJ;AAgDI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,gCAAA;UAAA,wBAAA;AA9CN;AAmDA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAjDF;AC1TE;EAAA;ID8WE,mBAAA;IACA,gBAAA;EAhDF;AACF;AAmDA;EACE,cAAA;EACA,qBAAA;AAjDF;AAmDE;EACE,0BAAA;AAjDJ;AAqDA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAnDF;AAsDA;EACE,cAAA;EACA,eAAA;AApDF;AAuDA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AArDF;AAwDA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAtDF;AAyDA;EACE,uBAAA;EAAA,mCAAA;UAAA,2BAAA;EACA,gBAAA;AAvDF;AA0DA;EACE,oBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;UAAA,cAAA;EACA,sBAAA;KAAA,mBAAA;AAxDF;AA2DA;EACE,+EAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAzDF;AA4DA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AA1DF;AC3XE;EAAA;IDwbE,WAAA;IACA,oBAAA;EAzDF;AACF;AA4DA;;ECxVE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;EDsVA,2BAAA;EAAA,4BAAA;EAAA,oBAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qEAAA;EAAA,6DAAA;EAAA,qDAAA;EAAA,kFAAA;AArDF;AAuDE;;;;EAEE,mBAAA;EACA,mBAAA;AAnDJ;AAsDE;;;;EAEE,mBAAA;EACA,eAAA;AAlDJ;AAoDI;;;;EACE,mBAAA;AA/CN;AAkDI;;;;EACE,8BAAA;UAAA,sBAAA;AA7CN;ACpbE;EAAA;;IDseE,eAAA;IACA,mBAAA;EA7CF;AACF;AAgDA;EACE,cAAA;EACA,cAAA;AA9CF;AAiDA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;AA/CF;ACpcE;EAAA;IDsfE,mBAAA;EA9CF;AACF;AAiDA;ECrZE,gBAAA;EAEA,SAAA;EAEA,aAAA;EACA,oBAAA;EDkZA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,0BAAA;AA5CF;AA8CE;EACE,aAAA;AA5CJ;AAgDA;EACE,0BAAA;UAAA,kBAAA;AA9CF;AAiDA;EACE,WAAA;EACA,mBAAA;AA/CF;ACheE;EAAA;IDkhBE,cAAA;EA9CF;AACF;AAiDA;EACE,kBAAA;EACA,qBAAA;AA/CF;ACzeE;EAAA;ID2hBE,qBAAA;EA9CF;AACF;AAiDA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AA/CF;ACpfE;EAAA;IDsiBE,mBAAA;EA9CF;AACF;AAiDA;EACE,cAAA;AA/CF;AAkDA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AAhDF;ACngBE;EAAA;IDsjBE,aAAA;IACA,qBAAA;IACA,qBAAA;EA/CF;AACF;AAkDA;EACE,aAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,iCAAA;EAAA,yBAAA;AAhDF;AAiDE;;EAEE,qBAAA;AA/CJ;AAkDE;EACE,qBAAA;AAhDJ;AC9hBE;EAAA;IDklBE,eAAA;IACA,eAAA;IACA,mBAAA;EAhDF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n@login-modal-bg: #fffdf5;\n// login_modal_bg.png 原图 570×342\n// 纵向：0~70% 与 80%~100% 固定不拉伸，仅 70%~80% 中间条带参与拉伸\n@login-modal-img-width: 570;\n@login-modal-img-height: 342;\n@login-modal-stretch-start: 0.7;\n@login-modal-stretch-end: 0.8;\n@login-modal-slice-top: (@login-modal-img-height * @login-modal-stretch-start); // 239px\n@login-modal-slice-bottom: (@login-modal-img-height * (1 - @login-modal-stretch-end)); // 68px\n@login-modal-slice-right: 48;\n@login-modal-slice-left: 48;\n// 在现有比例基础上整体放大背景（宽、高同比例）\n@login-modal-scale: 1.3;\n@login-modal-base-width: 360px;\n@login-modal-display-width: (@login-modal-base-width * @login-modal-scale);\n@login-modal-border-top: (239px * @login-modal-display-width / @login-modal-img-width);\n@login-modal-border-bottom: (68px * @login-modal-display-width / @login-modal-img-width);\n@login-modal-border-side: (48px * @login-modal-display-width / @login-modal-img-width);\n@login-modal-input-bg: #FFF1DA;\n@login-modal-orange: #fb7901;\n@login-modal-orange-dark: #e66f00;\n@login-modal-button-disabled: #d3d3d3;\n@login-modal-button-typing: #ffc692;\n@login-modal-text-muted: #c9a574;\n@login-modal-link: #626cda;\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(4px);\n  z-index: @z-index-modal;\n  .flex-center();\n  padding: @spacing-xl @spacing-md;\n\n  .mobile({\n    padding: @spacing-sm;\n    align-items: center;\n  });\n}\n\n.modal {\n  position: relative;\n  width: 100%;\n  max-width: (22.5rem * @login-modal-scale);\n  box-sizing: border-box;\n  height: auto;\n  border-style: solid;\n  border-width: @login-modal-border-top @login-modal-border-side @login-modal-border-bottom @login-modal-border-side;\n  border-color: transparent;\n  border-image-source: url('../../assets/img2/login_modal_bg.png');\n  border-image-slice: @login-modal-slice-top @login-modal-slice-right @login-modal-slice-bottom @login-modal-slice-left fill;\n  border-image-repeat: stretch;\n  border-image-width: @login-modal-border-top @login-modal-border-side @login-modal-border-bottom @login-modal-border-side;\n  animation: slideUp 0.3s ease;\n  overflow: visible;\n  .mobile({\n    max-width: min(22rem, 92vw);\n    // 按移动端弹窗参考宽度等比计算九宫格，避免只压扁高度导致顶图横向拉宽\n    @login-modal-mobile-ref-width: 352px;\n    @login-modal-mobile-border-top: (\n      @login-modal-slice-top * @login-modal-mobile-ref-width / @login-modal-img-width\n    );\n    @login-modal-mobile-border-bottom: (\n      @login-modal-slice-bottom * @login-modal-mobile-ref-width / @login-modal-img-width\n    );\n    @login-modal-mobile-border-side: (\n      @login-modal-slice-left * @login-modal-mobile-ref-width / @login-modal-img-width\n    );\n    border-width: @login-modal-mobile-border-top @login-modal-mobile-border-side\n      @login-modal-mobile-border-bottom @login-modal-mobile-border-side;\n    border-image-width: @login-modal-mobile-border-top @login-modal-mobile-border-side\n      @login-modal-mobile-border-bottom @login-modal-mobile-border-side;\n    max-height: calc(100dvh - 1.5rem);\n  });\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(1.25rem);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.closeButton {\n  .button-reset();\n  position: absolute;\n  top: -0.75rem;\n  right: -2rem;\n  width: 4rem;\n  height: 4rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 3;\n  transition: transform 0.2s ease;\n\n  &:hover {\n    transform: scale(1.05);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  .mobile({\n    top: -0.5rem;\n    right: -1.25rem;\n    width: 3.25rem;\n    height: 3.25rem;\n  });\n}\n\n.closeButtonImg {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: -4rem;\n  display: block;\n  object-fit: contain;\n\n  .mobile({\n    top: -2.75rem;\n  });\n}\n\n.logoWrap {\n  position: absolute;\n  top: -6.2rem;\n  left: 50%;\n  transform: translate(-50%, -42%);\n  z-index: 2;\n  pointer-events: none;\n\n  .mobile({\n    top: -5.25rem;\n    transform: translate(-50%, -36%);\n  });\n}\n\n.logoIcon {\n  width: 8rem;\n  height: auto;\n  display: block;\n\n  .mobile({\n    width: 6rem;\n  });\n}\n\n.modalBody {\n  padding: 0.5rem 1.25rem 0.25rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .mobile({\n    padding: 0.125rem 1rem 0.125rem;\n  });\n}\n\n.logoTextImg {\n  width: 9rem;\n  height: auto;\n  display: block;\n  margin-bottom: @spacing-xs;\n\n  .mobile({\n    width: 6.5rem;\n    margin-bottom: 0.125rem;\n  });\n}\n\n.subtitle {\n  margin: 0 0 @spacing-lg;\n  font-size: @font-size-md;\n  font-weight: 600;\n  color: #585858;\n  text-align: center;\n\n  .mobile({\n    margin-bottom: @spacing-sm;\n    font-size: @font-size-sm;\n    line-height: 1.35;\n  });\n}\n\n.form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: @spacing-md;\n\n  .mobile({\n    gap: @spacing-sm;\n  });\n}\n\n.inputGroup {\n  display: flex;\n  flex-direction: column;\n  gap: @spacing-xs;\n  width: 100%;\n}\n\n.fieldError {\n  font-size: @font-size-xs;\n  color: @error-color;\n  line-height: 1.4;\n}\n\n.input,\n.captchaInput {\n  width: 100%;\n  height: 3rem;\n  padding: 0 @spacing-md;\n  border: none;\n  border-radius: 0.625rem;\n  font-size: @font-size-md;\n  color: #585858;\n  outline: none;\n  background: @login-modal-input-bg;\n  transition: box-shadow 0.2s ease;\n\n  &:focus {\n    box-shadow: 0 0 0 2px fade(@login-modal-orange, 35%);\n  }\n\n  &::placeholder {\n    color: #c8b08a;\n  }\n\n  .mobile({\n    height: 2.625rem;\n    font-size: @font-size-sm;\n    padding: 0 0.75rem;\n  });\n}\n\n.captchaWrapper {\n  display: flex;\n  gap: @spacing-sm;\n  align-items: center;\n  width: 100%;\n  min-width: 0;\n}\n\n.captchaInput {\n  flex: 1;\n  min-width: 0;\n}\n\n.captchaImage {\n  width: 8.5rem;\n  height: 3rem;\n  border-radius: 0.625rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: @login-modal-input-bg;\n  flex-shrink: 0;\n  cursor: pointer;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    display: block;\n  }\n\n  .mobile({\n    width: 6.25rem;\n    height: 2.625rem;\n    max-width: 40%;\n  });\n}\n\n.captchaSpinner {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &::after {\n    content: '';\n    width: 1.4rem;\n    height: 1.4rem;\n    border: 2px solid #d0d0d0;\n    border-top-color: @login-modal-orange;\n    border-radius: 50%;\n    animation: captchaSpin 0.8s linear infinite;\n  }\n}\n\n@keyframes captchaSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.checkboxes {\n  display: flex;\n  flex-direction: column;\n  gap: @spacing-sm;\n  width: 100%;\n\n  .mobile({\n    gap: 0.375rem;\n  });\n}\n\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  gap: @spacing-xs;\n  cursor: pointer;\n  user-select: none;\n}\n\n.checkbox {\n  width: 1.125rem;\n  height: 1.125rem;\n  margin-top: 0.125rem;\n  flex-shrink: 0;\n  appearance: none;\n  -webkit-appearance: none;\n  border: 1px solid #d8c4a0;\n  border-radius: 0.25rem;\n  background: @white;\n  position: relative;\n  transition: all 0.2s ease;\n\n  &:checked {\n    border-color: @login-modal-orange;\n    background: @login-modal-orange;\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0.125rem;\n      left: 0.3125rem;\n      width: 0.25rem;\n      height: 0.5rem;\n      border: solid @white;\n      border-width: 0 2px 2px 0;\n      transform: rotate(45deg);\n    }\n  }\n}\n\n.checkboxText {\n  font-size: @font-size-sm;\n  color: @login-modal-text-muted;\n  line-height: 1.5;\n  font-weight: 600;\n\n  .mobile({\n    font-size: @font-size-xxs;\n    line-height: 1.4;\n  });\n}\n\n.link {\n  color: @login-modal-link;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n.errorMessage {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: @spacing-xs;\n  width: 100%;\n  text-align: center;\n}\n\n.errorIcon {\n  color: @error-color;\n  font-size: @font-size-md;\n}\n\n.errorText {\n  font-size: @font-size-sm;\n  color: @error-color;\n  line-height: 1.5;\n  font-weight: 600;\n}\n\n.verificationErrorMessage {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.375rem;\n  width: 100%;\n  text-align: center;\n  margin: 2rem 0;\n}\n\n.verificationErrorMessageField {\n  justify-content: flex-start;\n  text-align: left;\n}\n\n.verificationErrorIcon {\n  margin-top: 0.125rem;\n  width: 1.25rem;\n  height: 1.25rem;\n  flex-shrink: 0;\n  object-fit: contain;\n}\n\n.verificationErrorText {\n  font-family: @font-family-sans;\n  font-size: @font-size-md;\n  font-weight: 700;\n  color: #fc6c6c;\n  line-height: 1.5;\n}\n\n.actions {\n  display: flex;\n  flex-direction: column;\n  gap: @spacing-md;\n  width: 100%;\n  margin-top: @spacing-sm;\n\n  .mobile({\n    gap: @spacing-sm;\n    margin-top: 0.125rem;\n  });\n}\n\n.loginButton,\n.submitButton {\n  .button-reset();\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 3.125rem;\n  border: none;\n  border-radius: 999px;\n  color: @white;\n  font-size: 1.6rem;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  box-sizing: border-box;\n  cursor: not-allowed;\n  background: @login-modal-button-disabled;\n  transition: background 0.2s ease, transform 0.2s ease;\n\n  &.loginButtonTyping,\n  &.submitButtonTyping {\n    background: @login-modal-button-typing;\n    cursor: not-allowed;\n  }\n\n  &.loginButtonEnabled,\n  &.submitButtonEnabled {\n    background: @login-modal-orange;\n    cursor: pointer;\n\n    &:hover {\n      background: @login-modal-orange-dark;\n    }\n\n    &:active {\n      transform: scale(0.98);\n    }\n  }\n\n  .mobile({\n    height: 2.75rem;\n    font-size: @font-size-lg;\n  });\n}\n\n.loginButtonText {\n  display: block;\n  line-height: 1;\n}\n\n.noAccountLink {\n  width: 100%;\n  text-align: center;\n  margin-top: @spacing-sm;\n\n  .mobile({\n    margin-top: 0.25rem;\n  });\n}\n\n.linkButton {\n  .button-reset();\n  color: @login-modal-link;\n  font-size: @font-size-sm;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n  padding: 0;\n  text-decoration: underline;\n\n  &:hover {\n    opacity: 0.85;\n  }\n}\n\n.bindGameGuideButton {\n  align-self: center;\n}\n\n.verificationBody {\n  width: 100%;\n  padding-top: @spacing-sm;\n\n  .mobile({\n    padding-top: 0;\n  });\n}\n\n.instructions {\n  text-align: center;\n  margin-bottom: @spacing-lg;\n\n  .mobile({\n    margin-bottom: @spacing-sm;\n  });\n}\n\n.instructionText {\n  font-size: @font-size-md;\n  color: #585858;\n  line-height: 1.6;\n  margin: 0 0 @spacing-xs;\n\n  .mobile({\n    font-size: @font-size-sm;\n  });\n}\n\n.emailText {\n  color: @login-modal-link;\n}\n\n.codeInputs {\n  display: flex;\n  justify-content: center;\n  gap: @spacing-sm;\n  margin-bottom: @spacing-md;\n  margin-bottom: 2rem;\n\n  .mobile({\n    gap: 0.375rem;\n    margin-bottom: @spacing-sm;\n    margin: 1rem 0 2rem 0;\n  });\n}\n\n.codeInput {\n  width: 3.3rem;\n  height: 3.7rem;\n  border: 2px solid #FFD9B6;\n  border-radius: 0.625rem;\n  text-align: center;\n  font-size: @font-size-xl;\n  font-weight: 700;\n  color: #585858;\n  outline: none;\n  background: @login-modal-input-bg;\n  transition: all 0.2s ease;\n  &:focus,\n  &.codeInputFilled {\n    border-color: @login-modal-orange;\n  }\n\n  &.codeInputError {\n    border-color: @error-color;\n  }\n\n  .mobile({\n    width: 2.375rem;\n    height: 2.75rem;\n    font-size: @font-size-lg;\n  });\n}\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.mobileNarrow(@rules) {\n  @media (max-width: 413px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// 紧凑 PC（1024~1728 宽）：首页 banner 缩小与垂直微调\n.homeCompactPc(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) {\n    @rules();\n  }\n}\n\n.homeCompactPcShort(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) and (max-height: 1000px) {\n    @rules();\n  }\n}\n\n// 宽屏 PC（>1728 宽）：首页 banner 放大\n.homeWidePc(@rules) {\n  @media (min-width: 1729px) {\n    @rules();\n  }\n}\n\n// 浏览器放大/缩小时：横向裁切装饰溢出，纵向允许滚动避免内容显示不全\n.zoomScrollablePage() {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n// 可滚动弹窗蒙版：背景 fixed 铺满视口，内容区单独滚动，避免移动端滑出未覆盖区域\n.modalOverlayBackdrop(@bg: rgba(0, 0, 0, 0.55)) {\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n\n  &::before {\n    content: '';\n    position: fixed;\n    inset: 0;\n    background: @bg;\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    z-index: -1;\n    pointer-events: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `EU5OnG9Y`,
	"modal": `op9GWVqJ`,
	"slideUp": `Ahg0kVSH`,
	"closeButton": `AHoSyi2Q`,
	"closeButtonImg": `VcpyTpr2`,
	"logoWrap": `r2Ii3AwV`,
	"logoIcon": `a_OTZcS9`,
	"modalBody": `RZEapaIE`,
	"logoTextImg": `QnNUFumx`,
	"subtitle": `V11N6Xmb`,
	"form": `LQ4GV5UQ`,
	"inputGroup": `uKixh81J`,
	"fieldError": `TpCqxV6V`,
	"input": `yWQ_F6Pc`,
	"captchaInput": `Ktj2rkjK`,
	"captchaWrapper": `lA8J5cGz`,
	"captchaImage": `vEWt5a1l`,
	"captchaSpinner": `JHCNrsBG`,
	"captchaSpin": `Z4nBBmnM`,
	"checkboxes": `IM4vIx9F`,
	"checkboxLabel": `s8GPRhmT`,
	"checkbox": `wQN8nXim`,
	"checkboxText": `akpTNald`,
	"link": `TspOke8b`,
	"errorMessage": `ebRjCfxY`,
	"errorIcon": `oARyIHjo`,
	"errorText": `rcBvPlaR`,
	"verificationErrorMessage": `uUYqLxgA`,
	"verificationErrorMessageField": `YGS_s4J6`,
	"verificationErrorIcon": `_5Cus_dE`,
	"verificationErrorText": `VHjDJIIb`,
	"actions": `TDeoAMfO`,
	"loginButton": `iNq11l8G`,
	"submitButton": `hErnFAS6`,
	"loginButtonTyping": `KwGtNPpT`,
	"submitButtonTyping": `fOX7H6je`,
	"loginButtonEnabled": `n4XCYo7M`,
	"submitButtonEnabled": `oBXMq5iF`,
	"loginButtonText": `tk7AGilR`,
	"noAccountLink": `nLla_5zF`,
	"linkButton": `w40HhhDh`,
	"bindGameGuideButton": `jcxd1X4S`,
	"verificationBody": `YdWVriKx`,
	"instructions": `XvE1v2Gj`,
	"instructionText": `OeJHFi4I`,
	"emailText": `Q7xmq0i0`,
	"codeInputs": `udIRIWCo`,
	"codeInput": `L_6sNlDz`,
	"codeInputFilled": `aD1jR3B1`,
	"codeInputError": `hcJWp3gO`
};
export default ___CSS_LOADER_EXPORT___;
